/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IModule } from '../../../models/Roles/RolesContracts';

export const selectAllOrganizationList = (state: { globalRole: any; }) => state.globalRole.organizations;
export const selectAllModuleList = (state: { globalRole: any; }) => state.globalRole.modulesForApplication;
export const selectAllApplicationList = (state: { globalRole: any; }) => state.globalRole.applicationsForOrganization;
export const selectBuiltinPoliciesByRoleId = (state: { globalRole: any; }, roleId: number) =>
  state.globalRole.builtinPoliciesByRoleId[roleId];
export const selectModuleById = (
  state: { globalRole: { modulesById: Record<number, IModule> } },
  moduleId: number | undefined
) => {
  if (moduleId === undefined) {
    return undefined;
  }

  return state.globalRole.modulesById[moduleId];
};
export const selectBuiltinPoliciesToAssociate = (state: { globalRole: any }) =>
  state.globalRole.builtinPoliciesToAssociate.entities;
export const selectBuiltinPoliciesToAssociateCount = (state: { globalRole: any }) =>
  state.globalRole.builtinPoliciesToAssociate.page.count;
